import { render, staticRenderFns } from "./MediaValueDisplay.vue?vue&type=template&id=4e269486&scoped=true&"
import script from "./MediaValueDisplay.vue?vue&type=script&lang=ts&"
export * from "./MediaValueDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./MediaValueDisplay.vue?vue&type=style&index=0&id=4e269486&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e269486",
  null
  
)

export default component.exports